<template>
  <div class="mixin-components-container">
    <div
      v-loading="loading"
      element-loading-text="拼命加载中"
      id="waveform"
      ref="waveform"
      @click="returntime"
    ></div>
    <div class="audiocontroller">
      <span :disabled="!playSrc" @click="plays" class="playbtn">
        <img
          src="@/assets/img/play.png"
          alt=""
          v-show="flag == false"
          style="width: 21px; vertical-align: sub"
        />
        <img
          src="@/assets/img/pause.png"
          alt=""
          v-show="flag == true"
          style="width: 21px; vertical-align: sub"
        />
      </span>
      <div class="timetext">
        <span style="color: #409eff">{{ playback | formatSecond }}</span
        >/
        <span>{{ duration | formatSecond }}</span>
      </div>
      <div style="margin-left: 10px; float: left; line-height: 34px">
        <el-button class="speed" @click="DoubleSpeed">
          {{ ds + " X" }}
        </el-button>
      </div>
      <div class="block">
        <span slot="reference"
          ><img
            src="@/assets/img/volume.png"
            alt=""
            style="width: 21px; vertical-align: sub"
        /></span>
        <el-slider
          v-model="value"
          input-size="mini"
          @change="setVolume"
          :show-tooltip="false"
        ></el-slider>
      </div>
    </div>
  </div>
</template>
<script>
import WaveSurfer from "wavesurfer.js";
// 将整数转换成 时：分：秒的格式
function realFormatSecond(second) {
  var secondType = typeof second;
  if (secondType === "number" || secondType === "string") {
    second = parseInt(second);
    var hours = Math.floor(second / 3600);
    second = second - hours * 3600;
    var mimute = Math.floor(second / 60);
    second = second - mimute * 60;
    return (
      hours + ":" + ("0" + mimute).slice(-2) + ":" + ("0" + second).slice(-2)
    );
  } else {
    return "0:00:00";
  }
}
export default {
  name: "Details",
  data() {
    return {
      wavesurfer: null,
      // 指定播放功能的播放时间点
      appointTime: 1,
      // 播放倍速
      ds: 1,
      // 设置音量
      value: 50,
      playback: 0, //当前播放时间
      flag: false,
      timeData: "",
      duration: 0,
      loading: true,
    };
  },
  props: {
    playSrc: String,
  },
  mounted() {
    this.$nextTick(() => {
      this.wavesurfer = WaveSurfer.create({
        // 应该在其中绘制波形的CSS选择器或HTML元素。这是唯一必需的参数。
        container: this.$refs.waveform,
        // 光标以后的波形填充颜色。
        waveColor: "#e9e9e9",
        //光标以前的波形填充颜色。
        progressColor: "#409EFF",
        //不受支持的浏览器备选
        backend: "MediaElement",
        cursorColor: "#333",
        // 音频播放时间轴
        mediaControls: false,
        // 播放音频的速度
        audioRate: "1",
        height: "75",
      });
      let timeout = setTimeout(() => {
        this.loading = false;
        this.$message.warning("该文件格式加载不出来音轨");
        this.$emit("close", true);
      }, 3000);
      this.wavesurfer.on("error", function(e) {
        console.warn(e);
      });
      // 特别提醒：此处需要使用require(相对路径)，否则会报错
      this.wavesurfer.load(this.playSrc);
      this.wavesurfer.on("loading", (percents) => {
        // 当前加载的进度
        this.loading = true;
      });
      // 加载成功
      this.wavesurfer.on("ready", () => {
        this.loading = false;
        clearTimeout(timeout);
        this.duration = parseInt(this.wavesurfer.getDuration());
      });
      this.wavesurfer.setVolume(0.5);
    });
  },
  watch: {
    playback() {
      if (this.playback >= this.duration && this.playback !== 0) {
        this.flag = false;
        this.wavesurfer.stop();
      }
    },
    async playSrc() {
      await this.wavesurfer.load(this.playSrc);
      if (this.playSrc == "http://xiaolenew.oos-hazz.ctyunapi.cn/") {
        this.loading = false;
        this.$message.wrring("录音文件加载异常");
      }
      this.duration = 0;
      this.playback = 0;
      this.flag = false;
      this.wavesurfer.stop();
    },
  },
  methods: {
    returntime() {
      setTimeout(() => {
        this.playback = this.wavesurfer.getCurrentTime();
      }, 0);
    },
    // 播放时暂停，播放时暂停
    plays() {
      this.flag = !this.flag;
      this.wavesurfer.playPause();
      // this.duration = parseInt(this.wavesurfer.getDuration());
      if (this.flag == true) {
        this.timeData = setInterval(() => {
          this.playback = this.wavesurfer.getCurrentTime();
        }, 1000);
      } else {
        clearInterval(this.timeData);
      }
    },
    // 设置音量：
    setVolume(val) {
      this.wavesurfer.setVolume(val / 100);
    },
    // 指定播放
    appointPlay() {
      this.wavesurfer.play([this.appointTime]);
    },
    DoubleSpeed() {
      this.ds = this.ds == 1 ? 2 : 1;
      // console.log(this.ds);
      this.wavesurfer.setPlaybackRate(this.ds);
    },
  },
  filters: {
    // 将整数转化成时分秒
    formatSecond(second = 0) {
      return realFormatSecond(second);
    },
  },
};
</script>
<style lang="less" scoped>
.mixin-components-container {
  background-color: white;
  padding-top: 20px;
}
#waveform .wave {
  height: 80px;
}
.audiocontroller {
  width: 100%;
  height: 34px;
  border: 1px solid #e9e9e9;
  .playbtn {
    float: left;
    height: 24px;
    margin: 0 7px;
    line-height: 36px;
    color: #409eff;
    i {
      font-size: 19px;
    }
    .el-icon-video-play {
      line-height: 0;
    }
  }
  .timetext {
    line-height: 34px;
    float: left;
    font-size: 13px;
  }
  .speed {
    line-height: 3px;
    height: 24px;
    color: #409eff;
    background: #f9f9f9;
  }
  .block {
    display: flex;
    float: left;
    margin-left: 18px;
    span {
      line-height: 34px;
      margin-right: 20px;
    }
    .el-slider {
      width: 100px;
      /deep/ .el-slider__button-wrapper {
        top: -17px;
      }
      /deep/ .el-slider__bar {
        height: 3px;
      }
      /deep/ .el-slider__button {
        width: 5px;
        height: 5px;
      }
      /deep/ .el-slider__runway {
        height: 3px;
      }
    }
  }
}
</style>
